import { useEffect, useState, useCallback } from 'react'
import { logger } from '../utils/helpers/logger'
import { useSessionContext } from '../contexts/SessionContext'
import { getUserPatternDetails } from '../utils/helpers/supabase.helpers'
import { AgamiPattern } from '../types/supabase'

interface UseExperiencePatternDetailsOpts {
  patternId: string
  enabled?: boolean
}

export const useExperiencePatternDetails = (options: UseExperiencePatternDetailsOpts) => {
  const { user } = useSessionContext()
  const { patternId, enabled } = options

  const [isLoading, setIsLoading] = useState(true)
  const [patternDetails, setPatternDetails] = useState<AgamiPattern | null>(null)

  const fetchPatternDetails = useCallback(async () => {
    if (enabled === false) {
      return
    }

    const { data, error } = await getUserPatternDetails({
      patternId,
    })

    if (error || !data) {
      logger.error(error, 'FetchPatternDetails')
      setIsLoading(false)
      return
    }

    setPatternDetails(data)
    setIsLoading(false)
  }, [user, enabled, getUserPatternDetails])

  useEffect(() => {
    if (!user || !patternId || enabled === false) {
      return
    }
    fetchPatternDetails()
  }, [user, patternId, enabled])

  return { patternDetails, isLoading, refetch: fetchPatternDetails }
}
